// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HOAZ-","tabs":"styles_tabs__OyUW4"};